import type { ReactNode } from "react";

import { IgDialog } from "@intelligems/ig-theme";
import { Box } from "@mui/material";

import { ModuleDemoVideo } from "@src/components/ModuleDemoVideo/ModuleDemoVideo";
import { GateChip } from "@src/components/PricingGatedModal/GateChip";

interface ModuleTrialWelcomeDialogViewProps {
  isOpen: boolean;
  trialDays: number;
  moduleDisplayName: string;
  description: string;
  videoPlaybackId?: string;
  graphic: ReactNode;
  viewTemplatesLabel: string;
  onClose: () => void;
  onViewTemplates: () => void;
}

export function ModuleTrialWelcomeDialogView({
  isOpen,
  trialDays,
  moduleDisplayName,
  description,
  videoPlaybackId,
  graphic,
  viewTemplatesLabel,
  onClose,
  onViewTemplates,
}: ModuleTrialWelcomeDialogViewProps) {
  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={onClose}
      handleNoClick={onClose}
      handleYesClick={onViewTemplates}
      showCloseIcon={true}
      fullWidth={true}
      maxWidth="sm"
      dialogHeight={null}
      dialogContentWidth="100%"
      dialogImage={<GateChip label={`${trialDays} days free`} sx={{ mb: 2 }} />}
      title={`You've unlocked ${trialDays} days of ${moduleDisplayName}!`}
      subtitle={description}
      content={
        videoPlaybackId ? (
          <Box
            sx={{
              aspectRatio: "16 / 9",
              borderRadius: 2,
              overflow: "hidden",
              position: "relative",
              width: "100%",
            }}
          >
            <ModuleDemoVideo
              playbackId={videoPlaybackId}
              title={moduleDisplayName}
            />
          </Box>
        ) : (
          <Box sx={{ borderRadius: 2, overflow: "hidden" }}>{graphic}</Box>
        )
      }
      noButtonText="Do this later"
      yesButtonText={viewTemplatesLabel}
    />
  );
}
